/**
 * Browser Notification API wrapper.
 * Shows system notifications even when tab is in background.
 */

export function requestNotificationPermission(): Promise<boolean> {
  console.log('[Notification] requestPermission called');
  if (!('Notification' in window)) {
    console.log('[Notification] Notification API not available in this browser/context');
    return Promise.resolve(false);
  }
  console.log('[Notification] Current permission:', Notification.permission);
  if (Notification.permission === 'granted') return Promise.resolve(true);
  if (Notification.permission === 'denied') {
    console.log('[Notification] Permission was denied by user previously');
    return Promise.resolve(false);
  }
  console.log('[Notification] Requesting permission from user...');
  return Notification.requestPermission().then((p) => {
    console.log('[Notification] User responded with:', p);
    return p === 'granted';
  }).catch((err) => {
    console.error('[Notification] requestPermission() threw error:', err);
    return false;
  });
}

export function showBrowserNotification(title: string, body: string) {
  console.log('[Notification] showBrowserNotification called:', title, body);
  if (!('Notification' in window)) { console.log('[Notification] API not available'); return; }
  if (Notification.permission !== 'granted') { console.log('[Notification] Permission not granted, current:', Notification.permission); return; }
  try {
    const notification = new Notification(title, {
      body,
      icon: '/icons/icon-192x192.png',
      badge: '/icons/icon-192x192.png',
      tag: `macrorides-rider-${Date.now()}`,
      requireInteraction: true,
    });
    console.log('[Notification] Notification object created successfully');
    notification.onshow = () => console.log('[Notification] onshow fired');
    notification.onerror = (e) => console.error('[Notification] onerror fired:', e);
    notification.onclick = () => {
      window.focus();
      notification.close();
    };
    // Auto-close after 10 seconds
    setTimeout(() => notification.close(), 10000);
  } catch (err) {
    console.error('[Notification] Failed to create Notification:', err);
  }
}
